import React from "react";
import PropTypes from "prop-types";
import { Message } from "@qgiv/core-react";

const ReturningRegistrationBanner = ({ isVisible }) =>
    isVisible ? (
        <div className="grid">
            {/* Keep spacing above and below RegistrationContent consistent */}
            <div className="col col--12 -padding-top--30">
                <Message type="returning">
                    Welcome back! Review your details to complete your
                    registration!
                </Message>
            </div>
        </div>
    ) : null;

ReturningRegistrationBanner.propTypes = {
    isVisible: PropTypes.bool.isRequired,
};

export default ReturningRegistrationBanner;
